/**
 * Символы раздела «Освещение» для плана — по компоненту на светильник.
 *
 * Рисунок задан в собственном viewBox символа и растягивается в габарит объекта
 * (UI.SymbolFrame). Цвет — через currentColor. Ключ реестра — id элемента каталога.
 */
import { LightingId } from "@/shared/catalog";
import { UIKit, type SymbolComponent } from "@/shared/ui";

/** Вывод под бра */
export const SconceSymbol: SymbolComponent = (props) => (
	<UIKit.SymbolFrame viewBox="0 0 100 100" {...props}>
		<circle cx="50" cy="50" r="24" fill="none" stroke="currentColor" strokeWidth="3" />
		<path
			d="M50 16v14M50 84v-14M16 50h14M84 50h-14"
			stroke="currentColor"
			strokeWidth="3"
			strokeLinecap="round"
		/>
	</UIKit.SymbolFrame>
);

/** Люстра */
export const ChandelierSymbol: SymbolComponent = (props) => (
	<UIKit.SymbolFrame viewBox="0 0 600 600" {...props}>
		<circle cx="300" cy="300" r="250" fill="none" stroke="currentColor" strokeWidth="14" />
		<circle cx="300" cy="300" r="45" fill="currentColor" />
		<path
			d="M300 50v500M50 300h500M123 123l354 354M477 123L123 477"
			stroke="currentColor"
			strokeWidth="10"
			strokeLinecap="round"
		/>
	</UIKit.SymbolFrame>
);

/** Точечный светильник */
export const SpotSymbol: SymbolComponent = (props) => (
	<UIKit.SymbolFrame viewBox="0 0 90 90" {...props}>
		<circle cx="45" cy="45" r="36" fill="none" stroke="currentColor" strokeWidth="3.5" />
		<circle cx="45" cy="45" r="10" fill="currentColor" />
	</UIKit.SymbolFrame>
);

/** Потолочный светильник */
export const CeilingLampSymbol: SymbolComponent = (props) => (
	<UIKit.SymbolFrame viewBox="0 0 300 300" {...props}>
		<circle cx="150" cy="150" r="130" fill="none" stroke="currentColor" strokeWidth="7" />
		<path
			d="M55 55l190 190M245 55L55 245"
			stroke="currentColor"
			strokeWidth="6"
			strokeLinecap="round"
		/>
	</UIKit.SymbolFrame>
);

export const LIGHTING_SYMBOLS: Partial<Record<LightingId, SymbolComponent>> = {
	[LightingId.Sconce]: SconceSymbol,
	[LightingId.Chandelier]: ChandelierSymbol,
	[LightingId.Pendant]: ChandelierSymbol,
	[LightingId.Spot]: SpotSymbol,
	[LightingId.CeilingLamp]: CeilingLampSymbol,
};
